// import './styles/index.scss';
import { Table } from './components';

export default Table;
